import { InputTitle } from 'components/input/InputTitle';
import CommonSelect from 'components/select/CustomSelect';
import { AvatarUpload, Button, Row, Spacing, Typography, neutral, red } from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { HeaderDetailPage } from 'modules/dashboard/components/HeaderDetailPage';
import { TrainerPasswordForm } from 'modules/trainers/component/TrainerPasswordForm';
import { AvatarContainer, Container } from 'modules/trainers/styles/form';

import { CustomAvatar } from '../styles/avatar';

import { ReactComponent as AvatarIcon } from 'assets/icons/avatar.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';

import { MAX_FILE_SIZE } from 'constants/avatar';

import { LearnerPasswordForm } from '../component/LearnerPasswordForm';
import { LearnerProfileForm } from '../component/LearnerProfileForm';
import { useLearnerFormController } from '../core/controller/learner-form';

export const AddLearnerPage = () => {
  const {
    firstName,
    lastName,
    nickname,
    name,
    gender,
    phone,
    email,
    yearOfBirth,
    dayOfBirth,
    monthOfBirth,
    height,
    weight,
    password,
    bodyFat,
    visceralFatLevel,
    restingMetabolism,
    skeletalMuscle,
    handleChange,
    handleSubmit,
    handleChangePhone,
    handleChangeMeasurement,
    onChangeGender,
    disabled,
    emailStatus,
    handleChangeDate,
    goBack,
    roleKey,
    institutions,
    institutionId,
    onChangeInstitution,
    onChangeSearchInstitution,
    logoRef,
    onChangeAvatar,
    logoURL,
    onErrorAvatar,
    isErrorAvatar,
    onDeleteLogo,
    logo,
    isAccount,
    searchSelect,
    onChangeMonths,
    onChangeSearchMonths,
    searchSelectMonth,
    onChangeYear,
    onChangeSearchYears,
    searchSelectYear,
  } = useLearnerFormController();

  const isBiologicAdmin = roleKey === RoleKey.BIOLOGIC_ADMIN;

  return (
    <Container direction="column" style={{ maxWidth: 800 }}>
      <Spacing spacing="3xl" type="margin" placement="bottom">
        <HeaderDetailPage title="Add client" goBack={goBack} style={{ marginBottom: 0 }} />
      </Spacing>
      <Row direction="row">
        <Spacing spacing="3xl" type="margin" placement="right">
          <CustomAvatar>
            <AvatarUpload
              id="logo-learner"
              size="lg"
              ref={logoRef}
              icon={<UploadIcon />}
              accept=".png,.jpeg,.svg,.webp"
              maxFileSize={MAX_FILE_SIZE}
              onError={onErrorAvatar}
              onChangeFile={onChangeAvatar}
              url={logoURL.value}
              style={{ cursor: 'pointer' }}
            />
            <label htmlFor="logo-learner">
              <AvatarContainer>
                <AvatarIcon />
              </AvatarContainer>
            </label>
          </CustomAvatar>

          {isErrorAvatar && (
            <Typography
              weight={600}
              style={{
                marginTop: 4,
              }}
              color={red['red-5']}
              variant="body-3"
            >{`Max file size is 10Mb`}</Typography>
          )}
          {logo && (
            <Typography
              style={{
                whiteSpace: 'nowrap',
                color: '#FF4D4F',
                fontSize: '16px',
                cursor: 'pointer',
                textAlign: 'center',
                marginTop: 8,
              }}
              onClick={onDeleteLogo}
            >
              Remove
            </Typography>
          )}
        </Spacing>
        <Row direction="column">
          {isBiologicAdmin && (
            <Row
              direction="column"
              style={{
                paddingBottom: 48,
                borderBottom: `1px solid ${neutral['neutral-5']}`,
              }}
            >
              <Spacing spacing="md" type="margin" placement="bottom">
                <Typography
                  weight={500}
                  style={{ fontSize: 22, lineHeight: '30px', color: '#222222' }}
                >
                  General
                </Typography>
              </Spacing>
              <Spacing
                spacing="sm"
                placement="top"
                type="margin"
                style={{
                  width: '100%',
                }}
              >
                <InputTitle title="Institution" required />
                <CommonSelect
                  value={institutions.find((item: any) => item.value === institutionId)}
                  options={institutions.filter((item: any) =>
                    item.label.toLowerCase().includes(searchSelect.value.toLowerCase()),
                  )}
                  onChange={onChangeInstitution}
                  onInputChange={onChangeSearchInstitution}
                  noOptionsMessage={() => 'Not Found Institution'}
                />
              </Spacing>
            </Row>
          )}

          <LearnerProfileForm
            handleChange={handleChange}
            handleChangePhone={handleChangePhone}
            onChangeGender={onChangeGender}
            handleChangeMeasurement={handleChangeMeasurement}
            emailStatus={emailStatus}
            nickname={nickname}
            name={name}
            gender={gender}
            phone={phone}
            yearOfBirth={yearOfBirth}
            dayOfBirth={dayOfBirth}
            monthOfBirth={monthOfBirth}
            email={email ?? ''}
            height={height}
            weight={weight}
            firstName={firstName}
            lastName={lastName}
            bodyFat={bodyFat}
            visceralFatLevel={visceralFatLevel}
            restingMetabolism={restingMetabolism}
            skeletalMuscle={skeletalMuscle}
            handleChangeDate={handleChangeDate}
            isAccount={isAccount}
            password={password}
            onChangeMonths={onChangeMonths}
            onChangeSearchMonths={onChangeSearchMonths}
            searchSelectMonth={searchSelectMonth.value}
            onChangeYears={onChangeYear}
            searchSelectYear={searchSelectYear.value}
            onChangeSearchYears={onChangeSearchYears}
            // disabledMeasurement
          />

          <Spacing
            type="margin"
            style={{
              width: '100%',
              marginTop: 48,
            }}
          >
            <Button color="primary" onClick={() => handleSubmit()} disabled={disabled}>
              Add
            </Button>
          </Spacing>
        </Row>
      </Row>
    </Container>
  );
};
